<template>
  <v-breadcrumbs v-if="breadcrumbs.length > 1" :items="breadcrumbs" large>
    <template v-slot:item="{ item }">
      <router-breadcrumb :route="item"></router-breadcrumb>
    </template>
    <template v-slot:divider>
      <base-icon name="chevron-right"> </base-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
import RouterBreadcrumb from '@components/router-breadcrumb.vue'
export default {
  components: {
    RouterBreadcrumb,
  },
  computed: {
    breadcrumbs() {
      return this.$route.matched
        .filter((route) => {
          return !!route.meta.breadcrumb
        })
        .map((x) => {
          return {
            meta: x.meta,
            name: x.name,
            path: x.path,
            params: this.$route.params,
          }
        })
    },
  },
}
</script>

<style>
</style>